export const getThirdPartyCustomerRatingPlatform = (caseId: number) => {
  return caseId % 4 === 0
    ? {
        ratingPlatform: "Proven Expert",
        ratingPlatformLink: "https://www.provenexpert.com/rwbj76/",
      }
    : {
        ratingPlatform: "Trustpilot",
        ratingPlatformLink: "https://de.trustpilot.com/review/legalbird.de",
      };
};
